export default (params) => ({
  trigger: {
    name: 'product_type_section.view',
    params: params,
  },
  config: {
    schema: {
      item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
      has_highlighted_segment: {
        type: 'boolean',
      },
    },
    event: {
      name: 'view_items',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
